import { render, staticRenderFns } from "./kind_editor.vue?vue&type=template&id=3cd4bcff&scoped=true"
import script from "./kind_editor.vue?vue&type=script&lang=js"
export * from "./kind_editor.vue?vue&type=script&lang=js"
import style0 from "./kind_editor.vue?vue&type=style&index=0&id=3cd4bcff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4bcff",
  null
  
)

export default component.exports